import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { ComodatoContext } from 'contexts/ComodatoContext';
import { RemessasContext } from 'contexts/RemessasContext';
import { DropsContext } from 'contexts/DropsContext';
import { GridContext } from 'contexts/GridContext';
import { useModal } from 'components/Modals';
import ResumoModal from 'components/Modals/ResumoModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import Grid from 'components/Grid';
import TipoModal from './Modals/TipoModal';
import Filter from './filter';
import mock from './mock';

const Comodato = () => {
  const rotina = 'RemessasComodato';
  const titulo = 'Comodatos';
  const navigate = useNavigate();
  const { openModal } = useModal();
  const { drops } = useContext(DropsContext);
  const { exportPdf, exportXls } = useContext(GridContext);
  const { postRemessaCopia } = useContext(RemessasContext);
  const { comodato, getComodato, getLoading } = useContext(ComodatoContext);
  const { control, getValues, reset } = useForm({
    defaultValues: comodato?.filter,
  });

  const loadGrid = (props) => {
    if (props?.replace) {
      reset();
    }
    getComodato({ ...props, rotina, filter: getValues() });
  };

  const options = [
    {
      name: 'Adicionar',
      icon: 'add',
      action: () =>
        openModal(
          <TipoModal
            onSubmit={(url) => navigate(`/app/Remessas/Gerar${url}`)}
          />
        ),
    },
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({
          rotina,
          filter: getValues(),
          order: comodato?.order,
        }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({
          rotina,
          filter: getValues(),
          order: comodato?.order,
        }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={comodato?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
  ];
  const rowOptions = [
    {
      name: 'Detalhes',
      icon: 'visibility',
      action: ({ row }) => navigate(`/app/Documento/${row?.id}`),
    },
    {
      name: 'Copiar Remessa',
      icon: 'sync_problem',
      menu: true,
      action: ({ row }) =>
        postRemessaCopia({ data: { documento_id: row?.id }, cb: loadGrid }),
    },
    {
      name: 'Resumo da Remessa',
      icon: 'summarize',
      menu: true,
      action: ({ row }) => navigate(`/app/Remessas/Resumo/${row?.id}`),
    },
  ];

  return (
    <Container>
      <Header rotina={rotina} colunas={comodato?.colunas} titulo={titulo} />
      <Card>
        <Grid
          grid={comodato}
          mock={mock}
          options={options}
          rowOptions={rowOptions}
          control={control}
          checkboxSelection
          loading={getLoading}
          loadGrid={loadGrid}
          activeFilter={(getActiveFilter) => getActiveFilter(getValues())}
          FilterComponent={
            <Filter grid={comodato} control={control} drops={drops} />
          }
        />
      </Card>
    </Container>
  );
};

export default Comodato;
